import { Platform } from "react-native";

const baseColors = {
	black: "#000",
	white: "#fff",
	grey1: "#2d2d2d", // from dark to light
	grey2: "#2f2f2f",
	grey3: "#3e3e3e",
	grey4: "#4a4a4a",
	grey5: "#716f6f",
	grey6: "#8e8e93",
	grey7: "#969696",
	grey8: "#9b9b9b",
	grey9: "#d9d9d9", // pretty light here
	grey10: "#f6f6f6", // almost white
	lightBlack: "#181818",
	orange: process.env.REACT_APP_PRIMARY_COLOR || "#ff9600",
	aluminium: "#a4a8b9",
	silver: "#cacaca",
	red: Platform.OS === "web" ? "#ee1111" : "red",

	subtitle: "rgba(255,255,255,.7)",
	inputBorder: Platform.OS === "web" ? "#0e0b09" : "rgba(0,0,0,.2)",
	menuWrapperBorder: "#373636",
	menuEmail: "#6f6f6f",
	menuItemBorder: "#C8C7CC",
};

export default baseColors;
